import { computed } from "vue";

import { useStorageQuotas } from "~/composables/subscriptions/useStorageQuotas";
import { convertToToBytes } from "~/composables/units";

/**
 * Calcule les espaces souscrits, alloués et utilisés pour un stockage (S3 direct et PartnerS3)
 * Tout est converti en bytes pour cohérence dans les calculs et l'affichage.
 * @param totalQuotaAllowed - le quota total autorisé, en To (valeur reçue du backend)
 * @returns subscribedSpace, allocatedSpace, usedSpace (en bytes)
 */
export function useStorageStats (totalQuotaAllowed: number): {
	subscribedSpace: number;
	allocatedSpace: ComputedRef<number>;
	usedSpace: ComputedRef<number>;
} {
	// Données en dur pour le dev
	// const subscribedSpace = convertToToBytes(50);
	// const allocatedSpace = computed(() => convertToToBytes(25));
	// const usedSpace = computed(() => convertToToBytes(10));

	// return { subscribedSpace, allocatedSpace, usedSpace };

	const subscribedSpace = convertToToBytes(totalQuotaAllowed);

	const { totalAllocatedQuota, totalUsedSpace } = useStorageQuotas();

	const allocatedSpace = computed(() => totalAllocatedQuota.value);
	const usedSpace = computed(() => totalUsedSpace.value);

	return { subscribedSpace, allocatedSpace, usedSpace };
}
